import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import logo from "../assets/MaAz_Logo.png";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      alert("Please enter your registered email");
      return;
    }

    try {
      setLoading(true);
      setMessage("");

      const res = await api.post("/auth/forgot-password", {
        email: email.trim().toLowerCase(),
      });

      setMessage(
        res?.data?.message ||
          "If this email is registered, a password reset link has been sent."
      );
    } catch (err) {
      console.error("Forgot password error:", err);

      const errorMessage =
        err?.response?.data?.message ||
        "Unable to process your request. Please try again.";

      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src={logo} alt="MaAz Logo" style={styles.logoImg} />

        <h2 style={styles.heading}>Forgot Password</h2>

        <p style={styles.description}>
          Enter your registered student email. We will send you a password reset
          link.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            autoComplete="email"
            required
          />

          <button
            type="submit"
            style={{
              ...styles.button,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        {message && <div style={styles.successMessage}>{message}</div>}

        <button
          type="button"
          onClick={() => navigate("/")}
          style={styles.backButton}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}

export default ForgotPassword;

const styles = {
  container: {
    minHeight: "100vh",
    background: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    boxSizing: "border-box",
  },

  card: {
    width: "400px",
    maxWidth: "100%",
    background: "#fff",
    padding: "35px",
    borderRadius: "14px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    textAlign: "center",
    boxSizing: "border-box",
  },

  logoImg: {
    width: "350px",
    maxWidth: "100%",
    marginBottom: "20px",
  },

  heading: {
    marginBottom: "12px",
  },

  description: {
    color: "#666",
    fontSize: "14px",
    lineHeight: "1.6",
    marginBottom: "22px",
  },

  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
  },

  button: {
    width: "100%",
    padding: "12px",
    background: "#2c3e50",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontWeight: "600",
  },

  successMessage: {
    marginTop: "18px",
    padding: "12px",
    background: "#eafaf1",
    color: "#1e8449",
    borderRadius: "8px",
    fontSize: "14px",
    lineHeight: "1.5",
  },

  backButton: {
    marginTop: "18px",
    background: "none",
    border: "none",
    color: "#2c3e50",
    cursor: "pointer",
    textDecoration: "underline",
    fontSize: "14px",
    fontWeight: "600",
  },
};